import PageSpinner from "../../components/spinner/page";
import Score from "../../components/product/score";
import React from "react";
import { useRouter } from 'next/router';
import Page from "../../lib/page";
import MetaData, {Type} from "../../components/metadata";
import IngredientList from "../../components/ingredientList";
import TraceList from "../../components/traceList";
import NutrientList from "../../components/nutrientList";
import ProductList from "../../components/productList";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import ScoreExplained from "../../components/scoreExplained";
import Share from "../../components/share";
import Footer from "../../components/footer";
import Header from "../../components/header";
import Media from "../../components/media";
import BrandAPI from "../../lib/api/brand";
import Template from "../../lib/template";
import PageRenderer from "../../components/page";
import Breadcrumb from "../../components/breadcrumb";
import IngredientTypeProportions from "../../components/ingredientTypeProportions";
import Link from "next/link";
import Util from "../../lib/util";
import Texts from "../../lib/texts";
import BrandList from "../../components/brandList";
import { Sorting } from "../../index.d"

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function Brand(props) {
    const router = useRouter();
    const { t } = useTranslation();

    // fallback
    if(router.isFallback) return <PageSpinner />

    // init image
    const imageURL = props.brand.image ? props.brand.image.url : process.env.logoURL;

    // init breadcrumb
    let breadCrumbItems = [];
    for (let brand in props.brand.brands.hierarchy) {
        breadCrumbItems.push(
            {
                url: '/brand/' + encodeURIComponent(props.brand.brands.hierarchy[brand].id),
                name: props.brand.brands.hierarchy[brand].name
            }
        );
    }

    // add current-page to the breadcrumb
    breadCrumbItems.push(
        {
            url: '/brand/' + encodeURIComponent(props.brand.id),
            name: props.brand.name
        }
    );

    // base-url
    const utils = new Util();
    const nameWithHierarchy = utils.createName(breadCrumbItems);
    const baseURL = '/product/search?brand=' + encodeURIComponent(props.brand.id);

    // init general
    const description = t('brand.lead', { ns: 'glossary', brand: props.brand.name});

    // render
    return (
        <>
            {/* Metadata */}
            <MetaData
                type={Type.Website}
                title={props.brand.name}
                description={description}
                keywords={[t('brand'), nameWithHierarchy]}
                imageURL={null}
                urlOnlyForThisCountry={false}
                canonical={false}
            />

            {/* Header */}
            <Header />

            {/* Content */}
            <div className="container p-4 pt-3 pb-5">
                {/* Breadcrumb */}
                <Breadcrumb items={breadCrumbItems} />

                {/* Header */}
                <div className="row">
                    {/* Title */}
                    <h1 className="mt-2 mb-3 text-center text-md-start">
                        <small className="text-muted">{t('how.healthy.is.brand', {ns: 'glossary'})}<br /></small>

                        {/* Heading */}
                        <span className={'align-middle'}>{props.brand.name}</span>

                        {/* Symbol */}
                        {/*<div className={'d-block text-center d-md-inline ms-md-2'}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor"
                                 className="bi bi-building" viewBox="0 0 16 16">
                                <path fill-rule="evenodd"
                                      d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022zM6 8.694 1 10.36V15h5V8.694zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15z"/>
                                <path
                                    d="M2 11h1v1H2v-1zm2 0h1v1H4v-1zm-2 2h1v1H2v-1zm2 0h1v1H4v-1zm4-4h1v1H8V9zm2 0h1v1h-1V9zm-2 2h1v1H8v-1zm2 0h1v1h-1v-1zm2-2h1v1h-1V9zm0 2h1v1h-1v-1zM8 7h1v1H8V7zm2 0h1v1h-1V7zm2 0h1v1h-1V7zM8 5h1v1H8V5zm2 0h1v1h-1V5zm2 0h1v1h-1V5zm0-2h1v1h-1V3z"/>
                            </svg>
                        </div>*/}
                    </h1>

                    {/* Lead */}
                    <p className={'text-center text-md-start lead mb-4 pb-3'}>{description}</p>

                    <div className="col-md-7 col-lg-4 text-md-start">
                        {/* Score */}
                        <div className="w-100 d-inline-flex justify-content-center justify-content-md-start mb-3">
                            <Score
                                link={''}
                                target={'_self'}
                                score={props.brand.products.score}
                                nutrientScore={null}
                                ingredientScore={null}
                            />
                        </div>

                        {/* Score explained */}
                        <div className="d-flex justify-content-center justify-content-md-start mb-4">
                            <ScoreExplained />
                        </div>

                        {/* Share */}
                        <div className="row justify-content-center justify-content-md-start">
                            <Share imageURL={imageURL} />
                        </div>
                    </div>

                    {/* Score text */}
                    {props.texts && props.texts.score ? <p>{props.texts.score}</p> : ''}

                    {/* Image */}
                    {
                        props.brand.image ?
                            <div className="col-12 col-md-5 col-lg-3 mb-3 mb-md-0 mt-4 mt-md-0 text-center">
                                <Media
                                    data={
                                        {
                                            type: 'image',
                                            url: props.brand.image.url,
                                            description: nameWithHierarchy,
                                            loader: true,
                                            height: props.brand.image.height,
                                            width: props.brand.image.width,
                                            priority: true
                                        }
                                    }
                                    figure={false}
                                />
                            </div>
                        : ''
                    }
                </div>

                {/* Nutrients */}
                {props.brand.food && props.brand.food.nutrients && props.brand.food.nutrients.length
                    ?
                    <div id={'nutrients'} className={'mt-5 pt-4 col-12 col-lg-6'}>
                        <h2>{t('nutrients.of.brand', {ns: 'glossary', brand: props.brand.name})}</h2>
                        <h3 id="energy" className="h4 fw-normal">{t('energy')}
                            <b>{props.brand.food.energyKcal}</b> {t('kcal')} <small
                                className="text-muted">{t('per 100g')}</small></h3>
                        <NutrientList nutrients={props.brand.food.nutrients}/>
                        {props.texts && props.texts.nutrients ? <p className={'mt-4'}>{props.texts.nutrients}</p> : ''}
                    </div>
                    : ''
                }

                {/* Ingredients */}
                {props.brand.ingredients && props.brand.ingredients.length
                    ?
                    <div id={'ingredients'} className={'mt-5 pt-4 pb-1 col-12 col-lg-6'}>
                        <h2>{t('ingredients.of.brand', {ns: 'glossary', brand: props.brand.name})}</h2>
                        <IngredientList ingredients={props.brand.ingredients}/>
                        {props.texts && props.texts.ingredients ?
                            <p className={'mt-4 pt-2'}>{props.texts.ingredients}</p> : ''}
                    </div>
                    : ''
                }

                {/* Traces */}
                {props.brand.traces && props.brand.traces.length ?
                <div id={'traces'} className={'mt-5 pt-4 pb-1 col-12 col-lg-6'}>
                    <h2>{t('traces.of.brand', { ns: 'glossary', brand: props.brand.name})}</h2>
                    <TraceList traces={props.brand.traces} />
                    {props.texts && props.texts.traces ? <p className={'mt-4 pt-2'}>{props.texts.traces}</p> : ''}
                </div> : ''
                }

                {/* Ratio of Products */}
                {props.brand.products.items.length
                    ?
                    <>
                    <div id={'product-ratio'} className={'mt-5 pt-4 col-12 col-lg-9'}>
                        <h2 className="pb-2">{t('ratio.of.brand', { ns: 'glossary', brand: props.brand.name})}</h2>
                        <IngredientTypeProportions
                            ingredientTypes={props.brand.ingredientTypes}
                            filled={false}
                            baseURL={baseURL}
                        />
                        {props.texts && props.texts.ratio ? <p>{props.texts.ratio}</p> : ''}
                    </div>
                    <div id={'best-products'} className={'mt-5 pt-1 col-12 col-lg-9'}>
                        <h2 className="pb-2 mt-4">{t('healthiest.products.brand', {ns: 'glossary', brand: props.brand.name})}</h2>
                        <ProductList id={'best-products'} products={props.brand.products.items} />
                        {props.brand.products.count > 6
                            ?
                            <div className={'text-center mt-1'}>
                                <Link href={baseURL + '&sort=' + Sorting.SCORE_DESC} className={'text-center btn btn-primary'}>
                                    {t('view.all.products.count', {ns: 'glossary', count: props.brand.products.count})}
                                </Link>
                            </div>
                            : ''
                        }
                        {props.texts && props.texts.products ? <p className={'mt-4 pt-2'}>{props.texts.products}</p> : ''}
                    </div>
                    </>
                    : ''
                }

                {/* Child brands */}
                {props.brand.brands.children.length
                    ?
                    <>
                        <div id={'child-brands'} className={'mt-5 pt-1 col-12 col-lg-9'}>
                            <h2 className="pb-2 mt-4">{t('brands.of.brand', {ns: 'glossary', brand: props.brand.name})}</h2>
                            <BrandList brands={props.brand.brands.children} embed={false} />
                            {props.texts && props.texts.brands ? <p className={'mt-4 pt-2'}>{props.texts.brands}</p> : ''}
                        </div>
                    </>
                    : ''
                }

                {/* Blog-Posts */}
                {props.template.type
                    ?
                    <div id={'posts'} className={'mt-5 pt-4 col-12 col-lg-9'}>
                        <PageRenderer
                            type={props.template.type}
                            date={props.template.date}
                            data={props.template.data}
                            embed={true}
                        />
                    </div>
                    : ''
                }
            </div>

            {/* Footer */}
            <Footer />
        </>
    )
}
/**
 *
 * @param context
 * @returns {Promise<{notFound: boolean}>}
 */
export async function getStaticProps(context) {
    let page = new Page;
    page.init(context.locale);

    let brandAPI = new BrandAPI(
        page.language,
        page.country
    );

    let brand = {};
    const data = await brandAPI.selectById(context.params.id);

    if(data && 'ok' === data.header.status && data.body.brand) {
        brand = data.body.brand;
        data.body.brand.products.items.forEach(function(product) {
            product.link = '/' + context.locale + '/product/' + encodeURIComponent(product.id);
        })
    } else {
        throw Error('Unable to retrieve brand');
    }

    let texts = new Texts();
    await texts.init(
        page.language,
        'brand/' + data.body.brand.id
    );

    let template = new Template;
    await template.init(
        page.language,
        'blog/brand/' + encodeURIComponent(data.body.brand.name)
    );

    if(template.found) await template.enrichData(context.locale);

    return {
        props: {
            ...(await serverSideTranslations(context.locale, ['common', 'languages', 'countries', 'glossary', 'nutrients', 'ingredients', 'traces', 'ingredient-types'])),
            "brand": brand,
            "language": page.language,
            "country": page.country,
            "locale": page.locale,
            "template": {
                "type": template.found ? template.type : null,
                "date": template.found ? template.date : null,
                "data": template.found ? template.data : null
            },
            "texts": texts.found ? texts.data : null
        }, // will be passed to the page component as props
        revalidate: 86400, // In seconds
    };
}

/**
 *
 * @returns {Promise<{or: boolean, paths: [{params: {}}], fallback: boolean}>}
 */
export async function getStaticPaths() {
    return {
        paths: [],
        fallback: true
    };
}